import { Component } from 'react';

class ExtraButtons extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <>
                <div className="table-header-subtitle">
                    <div>
                        <div className="d-flex align-items-center">
                            <div className="all-data-dot red mr-10"></div> you are not ranking for
                            this keyword
                        </div>
                        <div className="d-flex align-items-center">
                            <div className="all-data-dot green mr-10"></div> you are ranking for
                            this keyword
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ExtraButtons;
